import { render, staticRenderFns, recyclableRender, components } from "./jianweikaifa-sign.vue?vue&type=template&id=7885cad7&"
var renderjs
import script from "./jianweikaifa-sign.vue?vue&type=script&lang=js&"
export * from "./jianweikaifa-sign.vue?vue&type=script&lang=js&"
import style0 from "./jianweikaifa-sign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/jianweikaifa-sign/components/jianweikaifa-sign/jianweikaifa-sign.vue"
export default component.exports